<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="currentColor"
    >
        <path
            fill-rule="evenodd"
            d="M3 3h8v8H3V3Zm2 2v4h4V5H5Zm8-2h8v8h-8V3Zm2 2v4h4V5h-4ZM3 13h8v8H3v-8Zm2 2v4h4v-4H5Z"
        />
        <path
            d="M6 6h2v2H6V6Zm10 0h2v2h-2V6ZM6 16h2v2H6v-2Zm7-3h2v2h-2v-2Zm2 2h2v2h-2v-2Zm-2 2h2v4h-2v-4Zm4-4h4v2h-4v-2Zm2 4h2v4h-2v-4Zm-2 2h2v2h-2v-2Z"
        />
    </svg>
</template>

<script>
export default { name: "QrCodeIcon" };
</script>
